module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadingFlag) ? _c('div', [_c('div', {
    staticClass: "ajaxLoading"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-tip"
  }, [_vm._v(_vm._s(_vm.loadingText))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70649c22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/commonComponents/loading.vue
// module id = 483
// module chunks = 1